import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import OfferView from './OfferView';
import OfferReservationView from './OfferReservationView';
import { formatOffers } from '../../../services/OfferService';
import * as offerActions from '../../../redux/offers';
import '../../../helpers';
import './Offer.css';
import moment from 'moment';

interface Props {
  type: OfferListType;
  business: Business;
  loadPastOffers: Function;
  loadOffers: Function;
  period?: string;
  offers: { data: Array<Offer>; loading: boolean; past_offers: any };
}

const Loader = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: ${(props) => (props.period ? '20px' : '25px')};
  margin: ${(props) => (props.period ? '30px 0px' : '100px 0px')};
  text-align: center;
`;

class OfferList extends React.Component<Props, {}> {
  componentDidMount() {
    const { business, type, period } = this.props;
    if (period) {
      if (this.props.offers.past_offers[period]) {
      } else {
        this.props.loadPastOffers(business.business_id, type, period);
      }
    } else {
      this.props.loadOffers(business.business_id, type);
    }
  }

  render() {
    let data: Array<OfferGroup> = [];
    const loader = <Loader period={this.props.period}>Loading offers...</Loader>;
    const noOffer = <Loader period={this.props.period}>There are no offers</Loader>;

    if (this.props.period) {
      data = formatOffers(this.props.offers.past_offers[this.props.period] || [], this.props.type);
      if (!this.props.offers.past_offers[this.props.period]) return loader;
      if (this.props.offers.past_offers[this.props.period].length === 0) return noOffer;
    } else {
      data = formatOffers(this.props.offers.data, this.props.type);
      if (this.props.offers.loading) return loader;
      if (this.props.offers.data.length === 0) return noOffer;
    }

    if (this.props.type === 'active') {
      return (
        <>
          {data
            .filter(
              (item) => item.offer.type === 'reservation_required' && item.offer.mode === 'apply'
            )
            .sort((a, b) => moment(a.offer.deliberation_until).diff(b.offer.deliberation_until))
            .map((item) => {
              if (item.offer.deliberation_status === 'finalized') return null;
              return <OfferView group={item} type={this.props.type} key={item.offer.id} />;
            })}
          {data
            .filter((item) => item.offer.type === 'reservation_placeholder')
            .map((item, index) => {
              return (
                <OfferReservationView
                  key={index}
                  title={item.offer.title}
                  type={this.props.type}
                  list={(item.parts as any).list}
                  date={item.offer.starts_at}
                />
              );
            })}
          {data
            .filter((item) => item.offer.type !== 'reservation_placeholder')
            .filter(
              (item) => !(item.offer.type === 'reservation_required' && item.offer.mode === 'apply')
            )
            .map((item, index) => {
              return <OfferView group={item} type={this.props.type} key={item.offer.id} />;
            })}
        </>
      );
    }
    if (this.props.type === 'upcoming')
      return (
        <>
          {data
            .filter(
              (item) =>
                item.offer.state === 'pending' || item.offer.verification_status == 'unverified'
            )
            .map((item, index) => {
              if (item.offer.type == 'reservation_placeholder')
                return (
                  <OfferReservationView
                    key={index}
                    title={item.offer.title}
                    type={this.props.type}
                    list={(item.parts as any).list}
                    date={item.offer.starts_at}
                  />
                );
              return <OfferView group={item} type={this.props.type} key={item.offer.id} />;
            })}
          {data
            .filter(
              (item) =>
                !(item.offer.state === 'pending' || item.offer.verification_status == 'unverified')
            )
            .map((item, index) => {
              if (item.offer.type == 'reservation_placeholder')
                return (
                  <OfferReservationView
                    key={index}
                    title={item.offer.title}
                    type={this.props.type}
                    list={(item.parts as any).list}
                    date={item.offer.starts_at}
                  />
                );
              return <OfferView group={item} type={this.props.type} key={item.offer.id} />;
            })}
        </>
      );

    return (
      <>
        {data.map((item, index) => {
          if (item.offer.type == 'reservation_placeholder')
            return (
              <OfferReservationView
                key={index}
                title={item.offer.title}
                type={this.props.type}
                list={(item.parts as any).list}
                date={item.offer.starts_at}
              />
            );
          return <OfferView group={item} type={this.props.type} key={item.offer.id} />;
        })}
      </>
    );
  }
}

const mapStateToProps = ({ business, offers }) => ({
  business,
  offers,
});

export default connect(mapStateToProps, offerActions)(OfferList);
